<template>
  <div class="container">
    <router-view></router-view>
    <!--<div class="alert" v-if="contentTypeDish.length > 0">-->
      <!--<p>注意, 以下图片为内容识别模式，根据内容标注</p>-->
      <!--<div class="alert-wrapper">-->
        <!--<div v-for="dish in contentTypeDish" :key="dish.dish_image_url">-->
          <!--<span>{{ dish.dish_name }}</span>-->
          <!--<img :src="dish.dish_image_url" alt="" width="50" />-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
  </div>
</template>
<script>
/* eslint-disable */
import {mapGetters, mapMutations, mapState} from 'vuex';
import imageWrapper from '../../components/imageMarkWrapper';
import batchTable from './batchTable';
import filterWrapper from '_c/filterWrapper';
import {apiGetBatchImageList, apiMarkBatchImages} from '../../api';

export default {
  name: 'dataMark',
  components: {
    imageWrapper,
    batchTable,
    filterWrapper
  },
  data () {
    return {
      currentBatch: [],
      AllBatchData: [],
      batchList: [],
      canteenList: [],
      batch_marked: '0'
    };
  },
  mounted () {
    // this.$router.push('/dataMark/batchList')
  },
  methods: {
    ...mapMutations(['emitLoading', 'removeLoading', 'setBatchList']),
    async getBatchImageList () {
      this.emitLoading();
      try {
        this.batch_marked = '0';
        let res = await apiGetBatchImageList({
          apiKey: this.api_key,
          canteen_id: this.listQuery.canteen.canteen_id,
          batch: this.currentBatch
        });
        this.setMarkImageList(res.data);
        this.batch_marked = res.batch_marked;
        this.removeLoading();
      } catch (e) {
        console.log(e);
        this.removeLoading();
        this.imageList = [];
      }
    },
    async submitMarked () {
      try {
        await apiMarkBatchImages({
          apiKey: this.api_key,
          canteen_id: this.listQuery.canteen.canteen_id,
          batch: this.currentBatch,
          label_info_list: this.markImageList
        });
        this.getBatchImageList();
      } catch (e) {
        console.log(e);
      }
    }
  },
  computed: {
    ...mapGetters(['modelList']),
    markImageList () {
      return this.$store.getters.markImageList();
    },
    api_key () {
      return this.$store.getters.userinfo().api_key;
    },
    ...mapState({
      eateryList (state) {
        this.listQuery.eatery = state.global.eateryList[0];
        return state.global.eateryList;
      },
      listQuery (state) {
        return state.filterWrapper.listQuery;
      }
    }),
    contentTypeDish () {
      let dishes = [];
      this.modelList.forEach(dish => {
        if (dish.dish_type === '2') {
          dishes.push(dish);
        }
      });
      return dishes;
    },
    btnDisabled () {
      let state = 0;
      if (this.markCount < this.markImageList.length) {
        state = true;
      }
      if (this.batch_marked) {
        state = true;
      }
      return state;
    },
    markCount () {
      let count = 0;
      this.markImageList.forEach(image => {
        if (image.class_id) {
          count++;
        }
      });
      return count;
    },
    currentBatchImages () {
      return this.AllBatchData[this.currentBatch] || [];
    }
  },
  watch: {
    // listQuery: {
    //   handler () {
    //   },
    //   deep: true
    // }
  }
};
</script>

<style lang="scss" scoped>
.container {
  .alert {
    position: fixed;
    width: 150px;
    top: 20vh;
    background-color: burlywood;
    border-radius: 10px;
    right: 5vw;
    z-index: 10;
  }
}
</style>
